import { ref } from 'vue';
import { Payee } from '@/payee.model';
import { useRouter } from 'vue-router';
import { Paged } from '@/shared/pagination/pageable-types';
import { API } from 'aws-amplify';
import { PaginationParameters } from '@/shared/pagination/pagination.composable';

const payee = ref<Payee>();
const isPayeeLoading = ref(false);

export function usePayee() {
  return {
    payee,
    populatePayee,
    getPayees,
    fetchPayee,
    createPayee,
    savePayee,
    deletePayee,
    isPayeeLoading,
  }
}

async function populatePayee(payeeId: string) {
  const router = useRouter();

  try {
    isPayeeLoading.value = true;
    payee.value = await fetchPayee(payeeId);
  } catch(error) {
    console.log(error);
    router.replace({name: 'PayeeNotFound'});
  } finally {
    isPayeeLoading.value = false;
  }
}

async function fetchPayee(payeeId: string): Promise<Payee> {
  return API.get('API', `/v1/payees/${payeeId}`, {});
}

async function getPayees(queryStringParameters?: PaginationParameters<Payee>): Promise<Paged<Payee>> {
   return API.get('API', `/v1/payees`, { queryStringParameters });
}

async function createPayee(payee: Payee) {
  return API.post('API', '/v1/payees', { body: payee });
}

async function savePayee(payee: Payee) {
  return API.put('API', `/v1/payees/${payee.id}`, { body: payee });
}

function deletePayee(payee: Payee) {
  return API.del('API', `/v1/payees/${payee.id}`, {});
}
